import React, { Component } from 'react';
import { connect } from 'react-redux';
import FullscreenLoader from '../../components/base/FullscreenLoader';

class FullscreenLoaderContainer extends Component {
  render() {
    return <FullscreenLoader {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    visible: state.app.fullscreenLoader,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FullscreenLoaderContainer);
